import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'libs/material.module';

@Component({
  standalone: true,
    selector: 'app-ag-pagination-toolbar',
    templateUrl: './ag-pagination-toolbar.component.html',
    styleUrls: ['./ag-pagination-toolbar.component.scss'],
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatSelectModule, MaterialModule]
})
export class AgPaginationToolbarComponent {
  @Input() showGenerateAvails: boolean = true;
  @Input() pageSizeOptions: number[] = [25, 50, 100, 2000];
  @Input() totalRows: number = 0;
  @Input() currentPageSize: number = 25;
  @Input() set currentPage(value: number) {
    this._currentPage = value;
    this.targetPage = value; // sync displayed input
  }
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() goToPage = new EventEmitter<number>();
  @Output() exportCsv = new EventEmitter<void>();
  @Output() generateAvails = new EventEmitter<void>();

  targetPage: number = 1;

  get totalPages(): number {
    const pages = Math.ceil(this.totalRows / this.currentPageSize) || 1;
    return pages;
  }

  onPageSizeChange(size: number) {
    this.pageSizeChange.emit(size);
  }

  onGoToPage() {
    const safePage = Math.min(Math.max(1, this.targetPage), this.totalPages);
    this.goToPage.emit(safePage);
  }

  get currentPage(): number {
    return this._currentPage;
  }
  private _currentPage: number = 1;

  onExportClick() {
    this.exportCsv.emit();
  }

  onGenerateAvailsClick(): void {
    this.generateAvails.emit();
  }
}
